module.exports = __webpack_public_path__ + "static/media/12.04b74b69.mp3";